import { inject } from 'mobx-react';
import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { RouteProps } from 'react-router';
import { APP_LOCALES } from '../../i18n';

import Button, { ButtonType } from '../../components/button/button';
import Image, { ImageType } from '../../components/image/image';
import FooterBottom from '../../components/layout/footer-bottom';
import { ROUTE_RESULT_DETAIL, ROUTE_ABOUT } from '../../RouteList';
import Planet from './components/Planet';
import messages from './messages';
import { SPORT_ICONS_URL } from '../../constants';

import './Universe.scss';
@inject('routing', 'dataStore')
class Universe extends React.Component<RouteProps & any, any> {
  public render() {
    const {
      routing: { push },
      dataStore
    } = this.props;

    const scores = dataStore.getScore().slice(0, 7);
    const { intl } = this.props;
    return (
      <React.Fragment>
        <div className={'o-wrapper o-wrapper--large c-universe-wrapper'}>
          <p className="c-universe__message">
            <FormattedMessage {...messages.intro} />
          </p>
          <div className="o-flex o-flex--wrap o-flex--justify-space-around u-padding-top-large c-planet-wrapper">
            {scores.length ? (
              scores
                .slice(0, 7)
                .map((score, index) => (
                  <Planet
                    key={score.id}
                    place={index}
                    sport={score.name}
                    src={`${SPORT_ICONS_URL}${score.id}.svg`}
                  />
                ))
            ) : (
              <p>
                <FormattedMessage {...messages.noResult} />
              </p>
            )}
          </div>
        </div>

        <FooterBottom hasButton twoButtons>
          <Image
            type={ImageType.startRocket}
            imgSrc="/images/svg/intro-rocket-clouds.svg"
            alt={'Clouds'}
            extraClasses={'c-image--sports-rocket'}
          />
          {dataStore.isPublicVersion ? (
            dataStore.locale === APP_LOCALES.EN_SG ? (
              <>
                <Button
                  label={
                    'For more details on your results, please download the report here'
                  }
                  type={ButtonType.primarySmall}
                  onClick={e => {
                    const win = window.open(
                      'https://app.sportamundi.com/loading',
                      '_blank'
                    );
                    dataStore.openPdfInNewTab(win);
                  }}
                />
                <Button
                  label={'About SportKompas'}
                  type={ButtonType.secondary}
                  onClick={() => push(ROUTE_ABOUT)}
                />
              </>
            ) : (
              <Button
                extraClasses="u-margin-left-auto"
                type={ButtonType.circleDone}
                onClick={() => push(ROUTE_ABOUT)}
              />
            )
          ) : (
            <Button
              type={ButtonType.primary}
              label={intl.formatMessage(messages.showAll)}
              onClick={() => push(ROUTE_RESULT_DETAIL)}
              disabled={scores.length === 0}
            />
          )}
        </FooterBottom>
      </React.Fragment>
    );
  }
}

export default injectIntl(Universe);



// WEBPACK FOOTER //
// ./src/containers/universe/Universe.tsx